import React from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

// Reusable history components from Doctor Console
import MedicalHistory from "../doctor-console/HistoriesData/MedicalHistory";
import FamilyHistory from "../doctor-console/HistoriesData/FamilyHistory";
import AllergyIntolerance from "../doctor-console/HistoriesData/AllergyIntolerance";
import AddictionHistory from "../doctor-console/HistoriesData/AddictionHistory";
import DrugHistory from "../doctor-console/HistoriesData/DrugHistory";
import SurgicalHistory from "../doctor-console/HistoriesData/SurgicalHistory";
import AdultVaccinationHistory from "../doctor-console/HistoriesData/AdultVaccinationHistory";
import MenstrualHistory from "../doctor-console/HistoriesData/MenstrualHistory";

// Custom MUI theme exposing palette entries like `defaultColor`, `grey.main`,
// `apple`, etc. that the doctor-console history components rely on. Without
// this provider, MUI's default theme is used and palette lookups such as
// `theme.palette.defaultColor.main` or Button `color="defaultColor"` throw
// "Cannot read properties of undefined (reading 'main' / 'dark')".
import { theme as doctorConsoleTheme } from "../doctor-console/StyledComponents";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { CaseSheetSection } from "./CaseSheetModalComponents";

const HistoryTab = ({ 
  medicalBackground, 
  updateMedicalBackground,
  gender
}) => {

  
  if (!medicalBackground) return null;

  const dateForAppointment = new Date();
  const noop = () => {};

  return (
    <ThemeProvider theme={doctorConsoleTheme}>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CaseSheetSection title="History of Past Illness" defaultExpanded>
          <MedicalHistory
            medicalHistoryData={medicalBackground["History of Past Illness"]}
          setMedicalHistoryData={(d) => updateMedicalBackground("History of Past Illness", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="History of Present Illness" defaultExpanded>
          <MedicalHistory
            medicalHistoryData={medicalBackground["History of Present Illness"]}
          setMedicalHistoryData={(d) => updateMedicalBackground("History of Present Illness", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          sectionName="History of Present Illness"
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="Family History" defaultExpanded>
        <FamilyHistory
          familyHistoryData={medicalBackground["Family History"]}
          setFamilyHistoryData={(d) => updateMedicalBackground("Family History", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="Drug History" defaultExpanded>
        <DrugHistory
          drugHistoryData={medicalBackground["Drug History"]}
          setDrugHistoryData={(d) => updateMedicalBackground("Drug History", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="Allergies" defaultExpanded>
        <AllergyIntolerance
          allergyHistoryData={medicalBackground["Allergies"]}
          setAllergyHistoryData={(d) => updateMedicalBackground("Allergies", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="Addiction History" defaultExpanded>
        <AddictionHistory
          addictionHistoryData={medicalBackground["Addiction History"]}
          setAddictionHistoryData={(d) => updateMedicalBackground("Addiction History", d)}
          dateForAppointment={dateForAppointment}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="Surgeries" defaultExpanded>
        <SurgicalHistory
          surgicalHistoryData={medicalBackground["Surgeries"]}
          setSurgicalHistoryData={(d) => updateMedicalBackground("Surgeries", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      <CaseSheetSection title="Adult Vaccination" defaultExpanded>
        <AdultVaccinationHistory
          adultVaccinationHistoryData={medicalBackground["Adult Vaccination"]}
          setAdultVaccinationHistoryData={(d) => updateMedicalBackground("Adult Vaccination", d)}
          dateForAppointment={dateForAppointment}
          setActiveHistorySection={noop}
          isAiEnabled={false}
        />
      </CaseSheetSection>

      {/* Menstrual History - Only shown for Female patients */}
      {(gender === "Female" || gender === "F") && (
        <CaseSheetSection title="Menstrual History" defaultExpanded>
          <MenstrualHistory
            menstrualHistoryData={medicalBackground["Menstrual History"]}
            setMenstrualHistoryData={(d) => updateMedicalBackground("Menstrual History", d)}
            dateForAppointment={dateForAppointment}
            isAiEnabled={false}
          />
        </CaseSheetSection>
      )}

      </LocalizationProvider>
    </Box>
    </ThemeProvider>
  );
};

export default HistoryTab;
